module.exports = __webpack_public_path__ + "media/images/crosswords/p3-e90d5c97cd0b4c29b8dde0fb76bb89fe.png";